import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import LoginPage from "@/pages/LoginPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CustomerAdmin from "@/pages/CustomerAdmin";
import SuperAdmin from "@/pages/SuperAdmin";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
    <Loader2 className="w-6 h-6 animate-spin text-sky-700" />
  </div>
);

const homeFor = (u) => (u.role === "super_admin" ? "/superadmin" : `/admin/${u.customer_id}`);

function Guard({ children, role, loginPath = "/login" }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to={loginPath} replace />;
  if (role && user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return <Navigate to={user ? homeFor(user) : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage portal="customer" />} />
            <Route path="/superadmin/login" element={<LoginPage portal="super" />} />
            <Route path="/glemt-passord" element={<ForgotPassword />} />
            <Route path="/nytt-passord" element={<ResetPassword />} />
            <Route path="/admin" element={<Guard><RootRedirect /></Guard>} />
            <Route path="/admin/:cid" element={<Guard><CustomerAdmin /></Guard>} />
            <Route
              path="/superadmin"
              element={<Guard role="super_admin" loginPath="/superadmin/login"><SuperAdmin /></Guard>}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
